/** One open report or journal can ask before Clinio navigates away. */
export type AppLeaveGuard = (proceed: () => void) => void;

let current: AppLeaveGuard | null = null;

export function setAppLeaveGuard(guard: AppLeaveGuard) {
  current = guard;
}

export function clearAppLeaveGuard(guard: AppLeaveGuard) {
  if (current === guard) current = null;
}

/** Run `proceed` now, or after the open editor saves or discards. */
export function confirmAppLeave(proceed: () => void) {
  if (current) current(proceed);
  else proceed();
}

export function resetAppLeaveGuard() {
  current = null;
}
